import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import clsx from 'clsx';

import { PointsDisplay } from 'C4';

const capped = (value, cap, minMax = 'max') => {
  if (typeof cap === 'object') {
    const { min, max } = cap;

    if (value <= min) return min;
    if (value >= max) return max;

    return value;
  }

  if (minMax === 'max') return value >= cap ? cap : value;
  if (minMax === 'min') return value <= cap ? cap : value;

  throw Error('minMax parameter should be either min or max');
};

export default class PointsAlert extends Component {
  constructor(props) {
    super(props);

    const { tiers, points, pointsGained } = this.props;
    const i = capped(this.getTieredValue() + 1, tiers.length - 1);

    const pointsToLevel = capped(tiers[i].points - (points - pointsGained), {
      min: 0, max: tiers[tiers.length - 1].points,
    });

    this.state = {
      pointsToLevel,
      startingValue: pointsToLevel,
      pointsCounter: capped(points - pointsGained, tiers[tiers.length - 1].points),
      transitions: {},
      nextRank: tiers[i].title,
      rankedUp: null,
    };

    this.getTieredValue = this.getTieredValue.bind(this);
  }

  componentDidMount() {
    const {
      delay, pointsGained, tiers, points,
    } = this.props;

    setTimeout(() => {
      this.interval = setInterval(() => {
        const { pointsToLevel, pointsCounter } = this.state;
        const transitionTime = Math.floor(1000 / pointsGained);
        const i = capped(this.getTieredValue() + 1, tiers.length - 1);

        const width = `${transitionTime}ms`;
        const height = `${transitionTime}ms`;

        const decrementPointsToLevel = pointsToLevel > (tiers[i].points - (pointsCounter));
        const incrementPointsCounter = pointsCounter < (points);

        if (!decrementPointsToLevel && !incrementPointsCounter) {
          clearInterval(this.interval);
        }

        if (pointsToLevel > 0) {
          this.setState({
            pointsToLevel: decrementPointsToLevel ? pointsToLevel - 1 : pointsToLevel,
            pointsCounter: capped((incrementPointsCounter
              ? pointsCounter + 1
              : pointsCounter), tiers[tiers.length - 1]),
            transitions: { width, height },
            nextRank: tiers[this.getTieredValue() + 1].title,
          });
        } else {
          clearInterval(this.interval);
          setTimeout(() => {
            this.setState({
              rankedUp: tiers[i].copy,
              pointsToLevel: 0,
            });
          }, delay);
        }
      }, Math.floor(2000 / pointsGained));
    }, delay);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getTieredValue(array = null, pointsOverride = null) {
    const { tiers, points: pointsProp } = this.props;
    const { pointsCounter } = this.state || {};
    let index = 0;
    tiers.forEach(({ points }, i) => { // Could be improved, maybe using filter / reduce?
      const currentPoints = pointsOverride || (pointsCounter === undefined ? pointsProp : pointsCounter);
      if (currentPoints > points) {
        index = i;
      }
    });

    if (array) return array[capped(index, 0, 'min')];
    return index;
  }

  render() {
    const {
      tiers, icon,
    } = this.props;

    const {
      pointsToLevel, pointsCounter, transitions, startingValue, nextRank, rankedUp,
    } = this.state;

    const { title, points } = tiers[tiers.length - 1];

    return (
      <div className="wrapper__alert">
        {icon && <img src={icon} alt="completion icon" />}
        <PointsDisplay
          tiers={tiers.map(({ points: p }) => p)}
          points={pointsCounter}
          startingValue={startingValue}
          animationDelay={1000}
          transitions={transitions}
          singleTier
        />
        {nextRank && !(title === nextRank && pointsCounter === points) && (
          <p>
            {i18n.translate('points.pointsToLevel', {
              pointsToLevel,
              points: 'XP',
              rank: nextRank.toUpperCase(),
            })}
          </p>
        )}
        <h2 className={clsx({ open: rankedUp !== null })}>{rankedUp || ''}</h2>
      </div>
    );
  }
}

PointsAlert.propTypes = {
  tiers: PropTypes.arrayOf(PropTypes.shape()),
  points: PropTypes.number,
  pointsGained: PropTypes.number,
  icon: PropTypes.string,
  delay: PropTypes.number,
};

PointsAlert.defaultProps = {
  tiers: [],
  points: 0,
  pointsGained: 0,
  icon: null,
  delay: 0,
};
